import { Toggle } from "@app/components/form/Toggle";
import { generateCapacityWithMergedSlots, isProductionCapacityActive } from "@app/helpers/productionCapacity";
import { IShop } from "@app/common";
import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import CapacityModal from "./ProductionCapacitySlotsModal";
import { Button } from "@app/components";
import { View } from "react-native";

interface CapacityScheduleProps {
  index: number;
}

export function CapacitySchedule({ index }: CapacityScheduleProps) {
  const { watch, setValue } = useFormContext();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <View style={{ marginTop: '1rem' }}>

      <Button title="Modifier la capacité" onPress={openModal} />

      {isModalOpen && (
        <CapacityModal
          index={index}
          onClose={closeModal}
        />
      )}
    </View>
  );
}